import { useCallback } from 'react'
import { JourneyBuilderMode } from '../enums'
import { stripUndefined } from '../../../_utils/strip-undefined'
import { handleNodeParamsUpdate } from '../helpers'

export function useSubmitAction(
    builder: any,
    domain: any,
    flags: any,
    isCatalogItemNotification: boolean,
    node: any,
    stateMode: any,
    validateNotificationBuilder: (builder: any, domain: any, flags: any, a?: boolean, b?: boolean) => Promise<boolean>,
    buildSubmittedNotificationPackages: (domain: any, builder: any, flags: any) => any[],
) {
    return useCallback(async () => {
        if (stateMode === JourneyBuilderMode.READONLY) {
            return node
        }

        const valid = await validateNotificationBuilder(builder, domain, flags, false, false)
        if (valid) {
            const builds = buildSubmittedNotificationPackages(domain, builder, flags)
            if (builds.length) {
                const notificationParam = builds[0]
                return handleNodeParamsUpdate(
                    node,
                    stripUndefined({
                        notification: notificationParam,
                        title: notificationParam.template.channels.default.title,
                        item_strategy: isCatalogItemNotification ? builder.selectedCatalogItemPickStrategy : undefined,
                    }),
                )
            }
        }
    }, [
        builder,
        domain,
        flags,
        isCatalogItemNotification,
        node,
        stateMode,
        validateNotificationBuilder,
        buildSubmittedNotificationPackages,
    ])
}
